import { encode } from 'js-base64';

interface LocalStorageTTLItem {
	value: string;
	expires: number;
}

export const localStorageSetTtlItem = (key: string, value: string, ttl: number): void =>
	localStorage.setItem(
		key,
		JSON.stringify({
			value,
			expires: Date.now() + ttl * 1000, // ttl is in seconds
		}),
	);

const localStorageGetTtlItem = (key: string): string | null => {
	const itemJson = localStorage.getItem(key);

	if (!itemJson) {
		return null;
	}
	const item: LocalStorageTTLItem = JSON.parse(itemJson);
	if (item.expires < Date.now()) {
		localStorage.removeItem(key);

		return null;
	}

	return item.value;
};

export const getScope = (customer: string, environment: string): string =>
	`renderingservice.${customer}.${environment}.access`;

const pollForToken = async (scope: string): Promise<string | null> => {
	let token = '';
	while (!token) {
		token = await new Promise((resolve) =>
			setTimeout(() => {
				resolve(localStorageGetTtlItem(`${scope}.token`) || '');
			}, 500),
		);
	}

	return token === 'STATE_MISMATCH' ? null : token;
};

const getBasename = () => {
	const base = window.location.pathname.replace('/auth/callback', '').replace(/\/$/, '');
	console.log('base=', base);

	return base;
};
export const checkForExistingToken = async (
	customer: string,
	renderService: string,
): Promise<string | null> => {
	const existingToken = localStorageGetTtlItem(`${getScope(customer, renderService)}.token`);

	return existingToken;
};
export const authenticate = async (
	customer: string,
	renderService: string,
): Promise<string | null> => {
	const { clientID, authServiceURL } = {
		clientID: window.location.hostname.includes('localhost')
			? 'Omnistream-local'
			: 'Omnistream-live',
		authServiceURL: 'https://authentication.zlthunder.net',
	};

	const state = {
		uuid: Math.random(),
		search: window.location.search,
	};

	const expectedState = encode(JSON.stringify(state));
	localStorage.setItem('auth.expectedState', expectedState);

	const authorizeUrl = `${authServiceURL}/api/v1/authorize`;
	const scope = getScope(customer, renderService);

	const params = {
		response_type: 'token',
		redirect_uri: `${window.location.origin}${getBasename()}/callback`,
		client_id: clientID,
		state: expectedState,
		scope,
	};
	const loginUrl = `${authorizeUrl}?${new URLSearchParams(params).toString()}`;

	// store in-flight test state so it can be resumed after auth.
	window.location.assign(loginUrl);

	return pollForToken(scope);
};
